var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{staticClass:"mt-3",attrs:{"striped":"","hover":"","responsive":"","items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(payment_categories_price)",fn:function(data){return [_vm._v(" "+_vm._s(parseInt(data.item.payment_categories_price).toLocaleString('id-ID'))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }